import { makeStyles, shorthands } from '@fluentui/react-components';

export const useStyles = makeStyles({
  statusItem: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    ...shorthands.gap('4px'),
  },
  nameText: {
    color: '#605E5C',
  },
  statusLabelMsg: {
    fontWeight: 'bold',
    color: '#707070',
  },
  statusLabelMsgWithPopover: {
    fontWeight: 'bold',
    color: '#707070',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  popover: {
    width: '240px',
  },
  popoverTitle: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    ...shorthands.gap('4px'),
    color: '#323130',
  },
  popoverTitleText: {
    fontWeight: 'bold',
  },
  popoverMsg: {
    marginTop: '16px',
    color: '#323130',
  },
  footer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: '12px',
  },
});
